import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry, tap, map, timeout } from 'rxjs/operators';
import { environment } from '../../../environments/environment'
import { CommonService } from './common.service';
import {Md5} from 'ts-md5/dist/md5';
import { isPlatformBrowser } from '@angular/common';
import { globals } from 'src/app/globals/globals';
import { Alert } from 'bootstrap';

function _window(): any {
  // return the global native browser window object
  return window;
}

@Injectable({
  providedIn: 'root'
})

export class PlansService {
  platformId(platformId: any) {
    throw new Error('Method not implemented.');
  }
  plan_init_params = {};
  promo_cod_dt = {};
  public planCategories: string[] = [];
  constructor(private http: HttpClient, private commonService: CommonService) { }

  options = { headers: new HttpHeaders ({ 'Content-Type': 'application/json' }) }

  // allPlans(region: string) {
  //   //http://216.48.179.109/catalog_lists/subscription.gzip?region=&auth_token=jqeGWxRKK7FK5zEk3xCM
  //   return this.http.get<any>(environment.apiURL+"catalog_lists/subscription.gzip?region="+region+"&auth_token="+environment.authtoken)
  //   .pipe(
  //     retry(1),
  //     catchError(this.commonService.handleError)
  //    );
  // }

  // Guest: full catalog. Logged in: valid_subscriptions (no category gate).
  allPlans(region: string) {
    const sessionId = window.localStorage ? window.localStorage.getItem('otv_user_id') : '';
    if (!sessionId) {
      const apiUrl = `${environment.apiURL}catalog_lists/subscription.gzip?region=${region}&auth_token=${environment.authtoken}`;
      return this.http.get<any>(apiUrl).pipe(
        retry(1),
        catchError(this.commonService.handleError)
      );
    }
    const apiUrl = `${environment.apiURL}catalog_lists/valid_subscriptions?region=${region}&auth_token=${environment.authtoken}&id=subscription&session_id=${sessionId}`;
    return this.http.post<any>(apiUrl, {}).pipe(
      retry(1),
      catchError(this.commonService.handleError)
    );
  }
  userPlans(sessionId: string, region: string) {
    //"users/{user_session}/user_plans?region=#{$region}","catalog"
    return this.http.get<any>(environment.apiURL+"users/"+sessionId+"/user_plans.gzip?region="+region+"&auth_token="+environment.authtoken)
    .pipe(
      retry(1),
      catchError(this.commonService.handleError)
     );
  }

  get nativeWindow(): any {
    return _window();
  }

  initTransaction(sessionId: string, sePlan: string, paymentGt: string, region: string, couponId: string, CouponCodeValue: string) {
    // console.log("service.ts : inside initTransaction...")
    //console.log("service.ts : paymentGt : " + paymentGt)

    var planDet = sePlan.split("|");
    var all_packs = [];
    var pack_data = {}

		pack_data['plan_categories'] = planDet[3];
    pack_data['category_type'] = "all_access_pack";
    pack_data['category_pack_id'] = planDet[0];
    pack_data['subscription_catalog_id'] = planDet[1];
    pack_data['plan_id'] = planDet[2];
    all_packs.push(pack_data);
    //var secret_key = "93038e8c2664cc5b149d"
    var secret_key = "2fcf2b11435c9452e163";
    var sec_key = secret_key+sessionId+region+planDet[2];
    const md5 = new Md5();
    var md5_sign = md5.appendStr(sec_key).end();
    //console.log(md5_sign);
    this.plan_init_params["us"] = md5_sign;
    //this.plan_init_params["payment_gateway"] = "cashfree"
    this.plan_init_params["auth_token"] = environment.authtoken;
    this.plan_init_params["payment_gateway"] = paymentGt;
    this.plan_init_params["platform"] = "WEB";
    this.plan_init_params["payment_info"] = {};
    this.plan_init_params["transaction_info"] = {};
    this.plan_init_params["user_info"] = {};
    this.plan_init_params["miscellaneous"] = {};
    this.plan_init_params["payment_info"]["net_amount"] = planDet[5].toString();
    this.plan_init_params["payment_info"]["price_charged"] = planDet[4].toString();
    this.plan_init_params["payment_info"]["currency"] = planDet[6];
    this.plan_init_params["payment_info"]["packs"] = all_packs;
    this.plan_init_params["payment_info"]["coupon_code"] = CouponCodeValue;
    this.plan_init_params["payment_info"]["coupon_code_id"] = couponId;
    this.plan_init_params["transaction_info"]["txn_message"] = "All access pack";
    this.plan_init_params["transaction_info"]["txn_status"] = "init";
    this.plan_init_params["user_info"]["email"] = sessionId;
    this.plan_init_params["user_info"]["mobile_number"] = "";
    this.plan_init_params["miscellaneous"]["browser"] = "Generic_Browser";

    //console.log("12"+JSON.stringify(this.plan_init_params));
    //console.log("service.ts : sessionId " + sessionId)
    //console.log("service.ts : environment.authtoken "+ environment.authtoken)
    //console.log("service.ts : JSON.stringify(this.plan_init_params) "+ JSON.stringify(this.plan_init_params))
    //console.log(this.options)
    //console.log("service.ts : environment.apiURL "+ environment.apiURL)
    //http://127.0.0.1:10000/users/ba49941d344c4d42e166695490cf0181/transactions?region=IN&auth_token=7TkpbsWP4w8zjyWVY9LT
    return this.http.post<any>(environment.apiURL+"users/"+sessionId+"/transactions.gzip?region="+region+"&auth_token="+environment.authtoken, JSON.stringify(this.plan_init_params), this.options)
    //return this.http.post<any>("https://8fb7836468f6.ngrok.io/users/04526e68fd58154896bd67a533290070/transactions?region="+region+"&auth_token="+environment.authtoken, JSON.stringify(this.plan_init_params), this.options)
    .pipe(
      // retry(1),
      catchError(this.commonService.handleError)
     );
  }

  // stripeSucces(id: string){
  //   //return this.http.get<any>("https://8fb7836468f6.ngrok.io/transactions/stripe_success?session_id="+id)
  //   return this.http.get<any>(environment.apiURL+"/transactions/stripe_success.gzip?session_id="+id)
  //   .pipe(
  //     retry(1),
  //     catchError(this.commonService.handleError)
  //    );

  // }

  // securePayment(paymentType: string, region: string) {
  //   return this.http.post<any>(environment.apiURL+"/payment_complete/"+paymentType+"/transactions.gzip?region="+region+"&auth_token="+environment.authtoken, JSON.stringify(this.plan_init_params), this.options)
  //   .pipe(
  //     retry(1),
  //     catchError(this.commonService.handleError)
  //    );
  // }

  ValidateCouponCode(sessionId: string, sePlan: string, promo_code: string, region: string){
    let promo_cod_dt = {}
    let planDet = sePlan.split("|");
    let pln_sig = ""
    var all_packs = [];
    var pack_data = {}
    pack_data['plan_categories'] = planDet[3];
    pack_data['category_type'] = "individual";
    pack_data['category_pack_id'] = planDet[0];
    pack_data['subscription_catalog_id'] = planDet[1];
    pack_data['plan_id'] = planDet[2];
    all_packs.push(pack_data);
    var secret_key = "93038e8c2664cc5b149d"
    var sec_key = secret_key+sessionId+region+planDet[2];
    const md5 = new Md5();
    var md5_sign = md5.appendStr(sec_key).end();
    //console.log(md5_sign);
    this.promo_cod_dt['us'] = md5_sign
    this.promo_cod_dt['packs'] = all_packs
    this.promo_cod_dt['coupon_code'] = promo_code
    this.promo_cod_dt['region'] = "IN"
    // console.log("promo code data");
    //console.log(this.promo_cod_dt);
    return this.http.post<any>(environment.apiURL+"v2/users/"+sessionId+"/apply_coupon_code.gzip?region="+region+"&auth_token="+environment.authtoken, JSON.stringify(this.promo_cod_dt), this.options)
      .pipe(
        retry(1),
        catchError(this.commonService.handleError)
       );
   }

   appConfigParams(region: string, destUrl: string){
     //http://13.212.17.223:3001/catalogs/message/items/app-config-params.gzip?auth_token=tgvnPAkwwbLhW8JszqB2&region=IN&item_language=en
     return this.http.get<any>(environment.apiURL+"catalogs/message/items/app-config-params.gzip?auth_token="+environment.authtoken+"&region="+region+"&item_language=en&destinationURL="+destUrl)
    .pipe(
      retry(1),
      catchError(this.commonService.handleError)
     );
   }

   doubleoption(obj: any, plan: any){
    //http://stagingdoubleoptin.9mobile.com.ng?username=etisalat&serviceID=116&destinationURL=”LWlf4m0m0%2B5FpbKQPB85nBiQAslM%2Fcj0V4wp3g41G%2BA%3D”&amount=5000&validity= 30
    //http://stagingdoubleoptin.9mobile.com.ng/?username=9TV&serviceID=MUSCOR10&destinationURL=RCZL%2FJZ8s%2FLUEq7TDTc7%2BigADMfpbnVb&amount=1000&validity=1
    let doubleopturl = obj['params_hash2']['config_params']['double_opt_url'];
    let destUrl = window.btoa(window.location.origin + "/plans_summary");
    // let doubleopturl = "http://stagingdoubleoptin.9mobile.com.ng/?username=9TV&serviceID=MUSCOR10&destinationURL=RCZL%2FJZ8s%2FLUEq7TDTc7%2BigADMfpbnVb&amount="+plan.region_prices.discount_price+"&validity="+plan.validity;
    // let doubleopturl = "http://stagingdoubleoptin.9mobile.com.ng/?username=9TV&serviceID=MUSCOR10&destinationURL=BNfH6qcZqpGUDRmMPKeb61zMu/k2bzn8SRmwjSWjpt1cmFPn7M95cHH3wuxpqbRU&amount=1000&validity=1";
    // let doubleopturl = environment.apiURL + "get_jwt_token?auth_token=" + environment.authtoken;
   return this.http.get<any>(doubleopturl, {observe: 'response'})
   .pipe(
    //  retry(1),
     catchError(this.commonService.handleError)
    );
  }

  tvodInit(plan: any, signed_url: any, catalog: any, token:string, tid:string, platform: string){
    let content_id, content_theme;
    if(catalog.theme == 'episode')
    {
      content_id = catalog.show_theme_id;
      content_theme = 'show'
    }
    else
    {
      content_id = catalog.content_id;
      content_theme = catalog.theme;
    }
    //http://13.212.17.223:3001/v2/user/subscriptions?auth_token=Nkz7pAqnqSPizUfNY8rx&region=NG
    let obj = {
      "auth_token": environment.authtoken,
      "miscellaneous": {
        },
      "payment_gateway": "9m_admin",
      "payment_info": {
        "currency": plan.region_prices.currency,
        "net_amount": plan.region_prices.price,
        "packs": [
          {
            "catalog_id": catalog.catalog_id,
            "category_type": 'TVOD',
            "content_id": content_id, //show, episode: show_theme_id
            "content_theme": content_theme, //show, episode: show
            "plan_categories": plan.plan_categories,
            "price_point_id": plan.region_price_id,
            "purchase_tag": plan.tag,
            "quality_tag": plan.quality,
            "subscription_theme_id": plan.subscription_theme_id
          }
        ],
        "price_charged": plan.region_prices.discount_price
      },
      "platform": platform,
      "region": plan.region_prices.region,
      "transaction_info": {
        "txn_message": "",
        "txn_status": "init",
        "pg_transaction_id": tid
      },
      "us": signed_url,
      "user_id": window.localStorage.getItem('otv_user_id'),
      "user_info": {
        "ext_user_id": window.localStorage.getItem('otv_user_login_id'),
        "mobile_number": "",
        "session_id": window.localStorage.getItem('otv_user_id')
      },
      "token": token
    }
    return this.http.post<any>(environment.apiURL+"v2/user/subscriptions.gzip?&auth_token="+environment.authtoken+"&region="+plan.region_prices.region, JSON.stringify(obj), this.options)
    .pipe(
      // retry(1),
      catchError(this.commonService.handleError)
    );
  }

  tvodSuccess(plan: any, signed_url: any, catalog: any, orderDetails: any, platform: string){
    let content_id, content_theme;
    if(catalog.theme == 'episode')
    {
      content_id = catalog.show_theme_id;
      content_theme = 'show'
    }
    else
    {
      content_id = catalog.content_id;
      content_theme = catalog.theme;
    }
    let obj = {
      "auth_token": environment.authtoken,
      "miscellaneous": {
        },
      "payment_gateway": "9m_admin",
      "payment_info": {
        "currency": plan.region_prices.currency,
        "net_amount": plan.region_prices.price,
        "packs": [
          {
            "catalog_id": catalog.catalog_id,
            "category_type": 'TVOD',
            "content_id": content_id,
            "content_theme": content_theme,
            "plan_categories": plan.plan_categories,
            "price_point_id": plan.region_price_id,
            "purchase_tag": plan.tag,
            "quality_tag": plan.quality,
            "subscription_theme_id": plan.subscription_theme_id
          }
        ],
        "price_charged": plan.region_prices.discount_price
      },
      "platform": platform,
      "region": plan.region_prices.region,
      "transaction_info": {
        "txn_message": "",
        "txn_status": "success",
        "order_id": orderDetails.order_id,
      },
      "us": signed_url,
      "user_id": window.localStorage.getItem('otv_user_id'),
      "user_info": {
        "ext_user_id": window.localStorage.getItem('otv_user_login_id'),
        "mobile_number": "",
        "session_id": window.localStorage.getItem('otv_user_id')
      }
    }
    return this.http.post<any>(environment.apiURL+"v2/user/subscriptions.gzip?&auth_token="+environment.authtoken+"&region="+plan.region_prices.region, JSON.stringify(obj), this.options)
    .pipe(
      // retry(1),
      timeout(20000),
      catchError(this.commonService.handleError)
    );
  }

  createBundles(session: any, items: any, plan: any){
    let obj = {
      "subscription_theme_id": plan.subscription_theme_id,
      "region_price_id": plan.region_price_id,
      "items": items
    };
    //http://13.212.17.223:3001/users/fa000a3e6331b6f69cc12c454019d7a0/user_bundles?auth_token=Nkz7pAqnqSPizUfNY8rx&region=NG
    return this.http.post<any>(environment.apiURL+"users/"+session+"/user_bundles.gzip?&auth_token="+environment.authtoken+"&region="+window.localStorage.getItem("region"), JSON.stringify(obj), this.options)
    .pipe(
      // retry(1),
      catchError(this.commonService.handleError)
    );
  }

  budleTvodInit(plan: any, signed_url: any, bundle_list_id: string, token:string, tid:string, catalog:any, platform: string){
    let content_id, content_theme;
    if( catalog.theme == 'show'|| catalog.theme == 'episode')
    {
      content_id = catalog.show_theme_id;
      content_theme = 'show'
    }
    else
    {
      content_id = catalog.content_id;
      content_theme = catalog.theme;
    }
    let obj= {
      "auth_token": environment.authtoken,
      "us": signed_url,
      "region": plan.region_prices.region,
      "payment_info": {
        "net_amount": plan.region_prices.price,
        "price_charged": plan.region_prices.discount_price,
        "currency": plan.region_prices.currency,
        "packs": [
          {
            "bundle_list_id": bundle_list_id,
            "plan_categories": plan.plan_categories,
            "category_type": plan.category_type,
            "content_id": content_id, //show, episode: show_theme_id
            "content_theme": content_theme, //show, episode: show
            "subscription_theme_id": plan.subscription_theme_id,
            "price_point_id": plan.region_price_id,
            "purchase_tag": plan.tag,
            "quality_tag": plan.quality
          }
        ]
      },
      "platform": platform,
      "transaction_info": {
        "txn_message": "",
        "txn_status": "init",
        "pg_transaction_id": tid
      },
      "user_info": {
        "ext_user_id": window.localStorage.getItem("otv_user_login_id"),
        "session_id": window.localStorage.getItem("otv_user_id")
      },
      "miscellaneous": {
        "browser": "Generic_Browser",
        "device_brand": "NA",
        "device_IMEI": "NA",
        "device_model": "NA",
        "device_OS": "NA",
        "device_type": "NA"
      },
      "payment_gateway": "9m_admin",
      "user_id": window.localStorage.getItem("otv_user_id"),
      "token": token
    }
    return this.http.post<any>(environment.apiURL+"v2/user/subscriptions.gzip?&auth_token="+environment.authtoken+"&region="+plan.region_prices.region, JSON.stringify(obj), this.options)
    .pipe(
      // retry(1),
      catchError(this.commonService.handleError)
    );
  }

   locationTrack(lat: any, long: any,  session:string){
    const obj = {
        session_id: session,
        lat:lat,
        long: long
      };
      return this.http.post<any>(
        environment.apiURL + "geo_location?auth_token=" + environment.authtoken,
        JSON.stringify(obj),
        this.options
      );
    }

  bundleTvodSuccess(plan: any, signed_url: any, catalog: any, orderDetails: any, platform:string){
    let content_id, content_theme;
    if(catalog.theme == 'show' || catalog.theme == 'episode')
    {
      content_id = catalog.show_theme_id;
      content_theme = 'show'
    }
    else
    {
      content_id = catalog.content_id;
      content_theme = catalog.theme;
    }
    let obj = {
      "auth_token": environment.authtoken,
      "us": signed_url,
      "region": plan.region_prices.region,
      "payment_info": {
        "net_amount": plan.region_prices.price,
        "price_charged": plan.region_prices.discount_price,
        "currency": plan.region_prices.currency,
        "packs": [
          {
            "bundle_list_id": window.localStorage.getItem("bundle_list_id"),
            "plan_categories": plan.plan_categories,
            "category_type": plan.category_type,
            "content_id": content_id, //show, episode: show_theme_id
            "content_theme": content_theme, //show, episode: show
            "subscription_theme_id": plan.subscription_theme_id,
            "price_point_id": plan.region_price_id,
            "purchase_tag": plan.tag,
            "quality_tag": plan.quality
          }
        ]
      },
      "platform": platform,
      "transaction_info": {
        "txn_message": "",
        "txn_status": "success",
        "order_id": orderDetails.order_id
      },
      "user_info": {
        "ext_user_id": window.localStorage.getItem("otv_user_login_id"),
        "session_id": window.localStorage.getItem("otv_user_id")
      },
      "miscellaneous": {
        "browser": "Generic_Browser",
        "device_brand": "NA",
        "device_IMEI": "NA",
        "device_model": "NA",
        "device_OS": "NA",
        "device_type": "NA"
      },
      "payment_gateway": "9m_admin",
      "user_id": window.localStorage.getItem("otv_user_id")
    }
    return this.http.post<any>(environment.apiURL+"v2/user/subscriptions.gzip?&auth_token="+environment.authtoken+"&region="+plan.region_prices.region, JSON.stringify(obj), this.options)
    .pipe(
      // retry(1),
      timeout(20000),
      catchError(this.commonService.handleError)
    );
  }

  allAccessInit(plan: any, signed_url: any, token: string, tid: string, catalog: any, platform: string){
    let content_id, content_theme;
    if(catalog.theme == 'show' || catalog.theme == 'episode')
    {
      content_id = catalog.show_theme_id;
      content_theme = 'show'
    }
    else
    {
      content_id = catalog.content_id;
      content_theme = catalog.theme;
    }
    let obj = {
      "auth_token": environment.authtoken,
      "miscellaneous": {
        },
      "payment_gateway": "9m_admin",
      "payment_info": {
        "currency": plan.region_prices.currency,
        "net_amount": plan.region_prices.price,
        "packs": [
          {
            "category_type": plan.category_type,
            "plan_categories": plan.plan_categories,
            "price_point_id": plan.region_price_id,
            "content_id": content_id, //show, episode: show_theme_id
            "content_theme": content_theme, //show, episode: show
            "purchase_tag": plan.tag,
            "quality_tag": plan.quality,
            "subscription_theme_id": plan.subscription_theme_id
          }
        ],
        "price_charged": plan.region_prices.discount_price
      },
      "platform": platform,
      "region": plan.region_prices.region,
      "transaction_info": {
        "txn_message": "",
        "txn_status": "init",
        "pg_transaction_id": tid
      },
      "us": signed_url,
      "user_id": window.localStorage.getItem("otv_user_id"),
      "user_info": {
        "ext_user_id": window.localStorage.getItem("otv_user_login_id"),
        "mobile_number": "",
        "session_id": window.localStorage.getItem("otv_user_id")
      },
      "token": token
    }
    return this.http.post<any>(environment.apiURL+"v2/user/subscriptions.gzip?&auth_token="+environment.authtoken+"&region="+plan.region_prices.region, JSON.stringify(obj), this.options)
    .pipe(
      // retry(1),
      catchError(this.commonService.handleError)
    );
  }

  allAccessSuccess(plan: any, signed_url: any, catalog: any, orderDetails: any, platform: string, autoRenewal:any){
    let content_id, content_theme;
    if(catalog.theme == 'show' || catalog.theme == 'episode')
    {
      content_id = catalog.show_theme_id;
      content_theme = 'show'
    }
    else
    {
      content_id = catalog.content_id;
      content_theme = catalog.theme;
    }
    let obj = {
      "auth_token": environment.authtoken,
      "miscellaneous": {
        },
      "payment_gateway": "9m_admin",
      "payment_info": {
        "currency": plan.region_prices.currency,
        "net_amount": plan.region_prices.price,
        "packs": [
          {
            "category_type": plan.category_type,
            "plan_categories": plan.plan_categories,
            "price_point_id": plan.region_price_id,
            "purchase_tag": plan.tag,

            "quality_tag": plan.quality,
            "subscription_theme_id": plan.subscription_theme_id
          }
        ],
        "price_charged": plan.region_prices.discount_price
      },
      "platform": platform,
      "region": plan.region_prices.region,
      "transaction_info": {
        "txn_message": "",
        "txn_status": "success",
        "order_id": orderDetails.order_id,
        "auto_renew": autoRenewal // to be made
      },
      "us": signed_url,
      "user_id": window.localStorage.getItem("otv_user_id"),
      "user_info": {
        "ext_user_id": window.localStorage.getItem("otv_user_login_id"),
        "mobile_number": "",
        "session_id": window.localStorage.getItem("otv_user_id")
      },
      "token": plan.token
    }
    return this.http.post<any>(environment.apiURL+"v2/user/subscriptions.gzip?&auth_token="+environment.authtoken+"&region="+plan.region_prices.region, JSON.stringify(obj), this.options)
    .pipe(
      // retry(1),
      timeout(20000),
      catchError(this.commonService.handleError)
    );
  }
  androidMovieDetails(catalogId: any, contentId: any, region: string) {
    return this.http.get<any>(environment.apiURL+"catalogs/"+catalogId+"/items/"+contentId+".gzip?region="+region+"&auth_token="+environment.authtoken)
    .pipe(
      // retry(1),
      catchError(this.commonService.handleError)
    );
  }
  androidEpisodeDetails(catalogId: any, contentId: any, region: string)
  {
    return this.http.get<any>(environment.apiURL+"catalogs/shows/"+catalogId+"/episodes/"+contentId+"?region="+region+"&auth_token="+environment.authtoken)
    .pipe(
      // retry(1),
      catchError(this.commonService.handleError)
    );
  }

  getStripeStatus(sessionId:string, orderId: string){
    // https://stagingapi.tarangplus.com/users/a097e7cdca0d688bf9080b67f0577482/stripe_status?order_id=O_432774_KF0F_DGQ_IN&auth_token=jqeGWxRKK7FK5zEk3xCM
    return this.http.get<any>(environment.apiURL+"users/"+sessionId+"/stripe_status?order_id="+orderId+"&auth_token="+environment.authtoken)
    .pipe(
      // retry(1),
      catchError(this.commonService.handleError)
    );
  }

 cancelRenewalRazorpay(transaction_id:string,sessionId:string,)
  {
    let obj = {
      "transaction_id": transaction_id
    }
    return this.http.post<any>(environment.apiURL+"users/"+sessionId+"/cancel_renewal?auth_token="+environment.authtoken,JSON.stringify(obj), this.options)

  }


  applyCouponCode(couponData: any, session_id) {
    http: return this.http
      .post<any>(
        environment.apiURL + 'users/' + session_id + '/apply_coupon_code',
        JSON.stringify(couponData),
        this.options
      )
      .pipe(retry(1), catchError(this.commonService.handleError));
  }


// downloadInvoice(sessionId: string, transaction_id: string): Observable<Blob> {
//   return this.http.get<any>(
//     `${environment.apiURL}users_invoice/${sessionId}/user_plans/${transaction_id}?auth_token=${environment.authtoken}`
//   ).pipe(
//     catchError(this.commonService.handleError)
//   );
// }
downloadInvoice(sessionId: string, transaction_id: string): Observable<Blob> {
  return this.http.get<Blob>(
    `${environment.apiURL}users_invoice/${sessionId}/user_plans/${transaction_id}?auth_token=${environment.authtoken}`,
    { responseType: 'blob' as 'json' } // Corrected here
  ).pipe(
    catchError(this.commonService.handleError) // Catch errors appropriately
  );
}


forgotEmail(data: any, region: string) {
  return this.http.post<any>(
    `${environment.apiURL}users/forgot_password?auth_token=${environment.authtoken}&region=${region}`,
    data
  );
}


changePassword(data: any, region: string) {
  return this.http.post<any>(
    `${environment.apiURL}users/reset_password?region=${region}&auth_token=${environment.authtoken}`,
    data
  );
}





googlePackActivate(payload: any) {
  return this.http.post<any>(
    `${environment.apiURL}payment_complete/google/secure_payment/${environment.authtoken}`,
    payload
  );
}
sendGooglePopupAcknowledgement(sessionId: string, payload: any) { 
  const authToken = environment.authtoken;
  return this.http.post<any>(
    `${environment.apiURL}google_popup_acknowledgement/${sessionId}?auth_token=${authToken}`,
    payload
  );
}
}
